/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './HouseholdList.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setEditNSIdentifierNumber, listDeleteAction } from 'redux/actions'
import { getNSIdentifierNumber } from '../../../../redux/reducers/appReducer';

const HouseholdList = ({ t, i18n, setIsError, reviewConfirmation = false, isSummary = false }) => {
  let history = useHistory()

  const houseHoldMembers = useSelector((state) => state.app.personalInformation.houseHoldMembers);
  const dispatch = useDispatch();
  useEffect(() => {
    try {
      if (!isSummary && houseHoldMembers.length === 0) {
        dispatch(setEditNSIdentifierNumber(''))
        history.push(`/${i18n.language}${t('routes.personal_info')}`)
      }
      // houseHoldMembers.map((householdMember) => {
      //   if (!isValidPermit(householdMember)) {
      //     // TODO: HOOKUP
      //     // dispatch(listDeleteAction(householdMember.plateNumber))
      //   }
      // })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [houseHoldMembers, history, i18n.language, isSummary, setIsError, t, dispatch])



  return (
    <div className="row">
      <div className="col-xs-12 col-lg-8">
        <div className={styles['overflow_mobile']}>
          {/* <table className={['table', styles['border_none']].join(' ')} style={{ marginBottom: '0px' }}> */}
          {houseHoldMembers.map((householdMember, i) => {
            return <HouseholdMemberRow key={i} isLast={i === houseHoldMembers.length - 1} householdMember={householdMember} t={t} i18n={i18n} setIsError={setIsError} reviewConfirmation={reviewConfirmation} isSummary={isSummary} />
          })}
          {/* </table> */}
        </div>
      </div>
    </div>
  )
}

const HouseholdMemberRow = ({ householdMember, i18n, t, setIsError, reviewConfirmation, isSummary, isLast }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { nsHealthCard, driverLicence } = useSelector((state) => state.app.addressTypeChange);

  const editHouseholdMemberOnClick = () => {
    try {

      const { nsHealthCardNumber, masterNumber } = householdMember;
      const nsIdentifierNumber = getNSIdentifierNumber({ nsHealthCard, driverLicence, nsHealthCardNumber, masterNumber });
      dispatch(setEditNSIdentifierNumber(nsIdentifierNumber));
      if (reviewConfirmation) {
        // TODO: HOOKUP
        // dispatch(editFromConfirmationAction(true));
      }
      history.push(`/${i18n.language}${t('routes.personal_info')}?isSummary=${isSummary}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const popUpBox = () => {
    let confirmText = window.confirm(`${t('are_you_sure')}`)
    if (confirmText == true) {
      // console.log('hit true')
      removeHouseholdMemberOnClick();
    }
    // else {
    //   console.log("do nothing")
    // }
  }

  const removeHouseholdMemberOnClick = () => {
    try {
      const { nsHealthCardNumber, masterNumber } = householdMember;
      const nsIdentifierNumber = getNSIdentifierNumber({ nsHealthCard, driverLicence, nsHealthCardNumber, masterNumber });

      dispatch(listDeleteAction("personalInformation", nsIdentifierNumber))
      if (reviewConfirmation) {
        // history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  // const dashIfNull = (data) => {
  //   return data ? data : '-'
  // }

  return (

    <div className="row">
      <div className="col-xs-12 col-lg-12">
        <div className="col-xs-12">
          <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
            <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "center" }}>
              <div className="col-xs-6">
                {isSummary && (
                  <>
                    <h3>{t('household_list.personal_info')}</h3>
                    <br></br>
                  </>
                )}
              </div>
              <div className="col-xs-6">

                <a href="#" className={[styles['edit_button']].join(' ')}
                  onClick={editHouseholdMemberOnClick}
                  value={t('household_list.edit')} name={t('household_list.edit')}>
                  {t('household_list.edit')}
                </a>
                {!isSummary && (
                  <a
                    href={reviewConfirmation ? `/${i18n.language}${t('routes.review_confirmation')}` : `/${i18n.language}${t('routes.household_list')}`}
                    className={styles['remove_button']}
                    // onClick={removeHouseholdMemberOnClick}
                    onClick={popUpBox}
                    value={t('household_list.remove')}
                    name={t('household_list.remove')}
                  >
                    {t('household_list.remove')}
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6"><strong>{t('household_list.name')}</strong></div>
            <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{householdMember.firstName} {householdMember.lastName}</div>
          </div>
          <hr />

          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6"><strong>{t('household_list.date_of_birth')}</strong></div>
            <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{householdMember.dateOfBirth}</div>
          </div>
          <hr />

          {householdMember.masterNumber && (
            <>
              <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6"><strong>{t('household_list.master_number')}</strong></div>
                <div className="col-xs-6">{householdMember.masterNumber.toUpperCase()}</div>
              </div><hr />
            </>
          )}


          {nsHealthCard && (
            <>
              <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6"><strong>{t('household_list.health_card_number')}</strong></div>
                <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{householdMember.nsHealthCardNumber}</div>
              </div><hr />
            </>
          )}


        </div>
      </div>
    </div>

    // <div >
    // <div className="col-xs-12" style={{ border: '1px solid black', marginBottom: isLast ? 0 : "1rem" }}>
    //   <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
    //     <div style={{ flexGrow: 1 }}>
    //       {isSummary && (
    //         <div className="col">
    //           <h2>{t('household_list.personal_info')}</h2>
    //         </div>
    //       )}

    //     </div>

    //   </div >

    //   <div className={"row " + styles['table-row']} style={{ display: 'flex', flexGrow: 1, }}>
    //     <div className="col"><strong>{t('household_list.name')}</strong></div>
    //     <div className="col">{householdMember.firstName} {householdMember.lastName}</div>
    //     {/* <div style={{ display: 'flex', margin: "1rem" }}> */}
    //     <div className={"col " + styles['actions_column']} >
    //       <a
    //         href="#"
    //         className={[styles['edit_button']].join(' ')}
    //         onClick={editHouseholdMemberOnClick}
    //         value={t('household_list.edit')}
    //         name={t('household_list.edit')}
    //       >
    //         {t('household_list.edit')}
    //       </a>
    //       {!isSummary && (
    //         <a
    //           href={reviewConfirmation ? `/${i18n.language}${t('routes.review_confirmation')}` : `/${i18n.language}${t('routes.household_list')}`}
    //           className={styles['remove_button']}
    //           // onClick={removeHouseholdMemberOnClick}
    //           onClick={popUpBox}
    //           value={t('household_list.remove')}
    //           name={t('household_list.remove')}
    //         >
    //           {t('household_list.remove')}
    //         </a>
    //       )}
    //     </div>
    //     {/* </div> */}
    //   </div>
    //   <div className={"row " + styles['table-row']} style={{ display: 'flex', flexGrow: 1, }}>
    //     <div className="col"><strong>{t('household_list.date_of_birth')}</strong></div>
    //     <div className="col">{householdMember.dateOfBirth}</div>
    //     <div className={"col " + styles['actions_column']} />
    //   </div>
    //   {householdMember.masterNumber && (
    //     <div className={"row " + styles['table-row']} style={{ display: 'flex', flexGrow: 1, }}>
    //       <div className="col"><strong>{t('household_list.master_number')}</strong></div>
    //       <div className={"col " + styles['line-break']}>{householdMember.masterNumber.toUpperCase()} </div>
    //       <div className={"col " + styles['actions_column']} />
    //     </div>
    //   )}


    //   {nsHealthCard && (
    //     <div className={"row " + styles['table-row']} style={{ display: 'flex', flexGrow: 1, }}>
    //       <div className="col"><strong>{t('household_list.health_card_number')}</strong></div>
    //       <div className={"col " + styles['line-break']}>{householdMember.nsHealthCardNumber}</div>
    //       <div className={"col " + styles['actions_column']} />
    //     </div>
    //   )}



    // </div>
    // </div>
    // <tbody style={{ border: '1px solid black' }}>
    //   <tr>
    //     <td><strong>{t('household_list.name')}</strong></td>
    //     <td ref={permitEl}>{householdMember.firstName} {householdMember.lastName}</td>

    //     <td>
    //       <div style={{ display: 'flex' }}>
    //         <button
    //           className={['btn-xs btn-default', styles['edit_button']].join(' ')}
    //           onClick={editHouseholdMemberOnClick}
    //           value={t('household_list.edit')}
    //           name={t('household_list.edit')}
    //         >
    //           {t('household_list.edit')}
    //         </button>
    //         <a
    //           href={reviewConfirmation ? `/${i18n.language}${t('routes.review_confirmation')}` : `/${i18n.language}${t('routes.household_list')}`}
    //           className={styles['remove_button']}
    //           onClick={removeHouseholdMemberOnClick}
    //           value={t('household_list.remove')}
    //           name={t('household_list.remove')}
    //         >
    //           {t('household_list.remove')}
    //         </a>
    //       </div>
    //     </td>
    //   </tr>
    //   <tr>
    //     <td><strong>{t('household_list.date_of_birth')}</strong></td>
    //     <td>{dashIfNull(householdMember.dateOfBirth)}</td>
    //     <td></td>
    //   </tr>
    //   <tr>
    //     <td><strong>{t('household_list.master_number')}</strong></td>
    //     <td>{dashIfNull(householdMember.masterNumber)}</td>
    //     <td></td>
    //   </tr>
    //   <tr>
    //     <td><strong>{t('household_list.health_card_number')}</strong></td>
    //     <td>{dashIfNull(householdMember.nsHealthCardNumber)}</td>
    //     <td></td>
    //   </tr>
    // </tbody>
  )
}

export default withTranslation('common')(HouseholdList)
